import { render, staticRenderFns } from "./DownloadContents.vue?vue&type=template&id=09773bfe&scoped=true&"
import script from "./DownloadContents.vue?vue&type=script&lang=js&"
export * from "./DownloadContents.vue?vue&type=script&lang=js&"
import style0 from "./DownloadContents.vue?vue&type=style&index=0&id=09773bfe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09773bfe",
  null
  
)

export default component.exports